import type { IconSvgObject } from './types';

const UserSharingIcon: IconSvgObject = [
  ["path", { d: "M16 11C16 8.79086 14.2091 7 12 7C9.79086 7 8 8.79086 8 11C8 13.2091 9.79086 15 12 15C14.2091 15 16 13.2091 16 11Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5.07026 15C4.38958 13.8233 4 12.4571 4 11C4 6.58172 7.58172 3 12 3C16.4183 3 20 6.58172 20 11C20 12.4571 19.6104 13.8233 18.9297 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18 21C18 17.6863 15.3137 15 12 15C8.68629 15 6 17.6863 6 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default UserSharingIcon;
